import React from 'react';
import { View, TextInput, Pressable, StyleSheet, Image } from 'react-native';
import { COLOR, FONT_SIZE, THEME } from '../../constants/styles';
import {
  OPComponent,
  FormTextArea,
  Container,
  I18n,
  Utils,
  NavBar,
  Navigation,
} from '../components';
import AddAnotherButton from './add_another_button';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { sendInvitations, resetState } from './actions';

class InviteEmailPhone extends OPComponent {
  static navigatorStyle = NavBar && NavBar.navigatorStyle;

  constructor(props) {
    super(props);

    this.state = {
      focusedInputIndex: 0,
      items: [''],
      errorMessage: null,
      messageValue: '',
    };

    this._firstFocus = true;
    this.inputRefs = {};

    const screenType = (this.screenType = this.props.email_or_phone),
      isEmail = (this.isEmail = screenType === 'email');
    this.isPhone = screenType === 'phone';

    // Prepare some text labels
    const i18nKey = 'invite_email_phone.' + (isEmail ? 'email' : 'phone');
    this.labelTxt = I18n.t(i18nKey);
    this.labelTxtCapitalized = I18n.ce(i18nKey);
    this.labelTxtAllCaps = I18n.ac(i18nKey);
  }

  navigationButtonPressed = ({ buttonId }) => {
    if (NavBar.handleButtonPress2(buttonId, this)) return;
  };

  componentDidMount() {
    Utils.trackScreen('Invitations', 'Invite Email');
    Navigation.registerForButtonEvents(this);

    Navigation.setButtons(
      {
        rightButtons: [
          {
            text: I18n.c1('invite.invite'),
            id: 'save',
          },
        ],
        leftButtons: this.props.noBacksies ? [NavBar.buttons.done] : [NavBar.buttons.cancel],
      },
      this.props.componentId
    );

    const i = this.state.focusedInputIndex;
    // TODO: with react-native-navigation > 1.1.483 callback
    setTimeout(() => {
      this.focusInput(i);
    }, 300);
  }

  componentWillUnmount() {
    Navigation.unRegisterForButtonEvents(this);
    if (this.props.noBacksies) {
      this.props.actions.resetState();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.status === 'success' && this.props.status !== 'success')
      Navigation.close(this.props);

    if (nextProps.errorMessage) {
      this.setState({
        errorMessage: Utils.errorMessageFromObject(nextProps.errorMessage),
      });
    }
  }

  onSave = () => {
    Utils.trackEvent('Action', 'Tap', 'Submit Contacts');

    if (!this.state.items.length || !this.state.items[0].trim()) {
      this.setState({ errorMessage: I18n.t('invite.pleaseAddContact') });
      return;
    }

    let invalid = null;
    this.state.items.forEach((item) => {
      if (!Utils.validate[this.screenType](item.trim())) invalid = item;
    });
    if (!invalid) {
      this.setState({
        errorMessage: null,
      });
    } else {
      this.setState({
        errorMessage: I18n.t('invite_email_phone.validationError', {
          type: this.labelTxtCapitalized,
          msg: invalid,
        }),
      });
      return;
    }

    let submitArray = [];
    let fillFieldName = this.isEmail ? 'inviteeEmail' : 'inviteePhone';
    let nullFieldName = this.isPhone ? 'inviteeEmail' : 'inviteePhone';
    this.state.items.forEach((item) => {
      if (item && item.trim()) submitArray.push({ [fillFieldName]: item, [nullFieldName]: null });
    });

    this.props.actions.sendInvitations(this.props.caseId, submitArray, this.state.messageValue);
  };

  handleAddAnotherButtonPress() {
    Utils.trackEvent('Action', 'Tap', 'Add Contact');
    let invalid = null;
    this.state.items.forEach((item) => {
      if (!Utils.validate[this.screenType](item.trim())) invalid = item;
    });
    if (invalid) {
      this.setState({
        errorMessage: I18n.t('invite_email_phone.validationError', {
          type: this.labelTxtCapitalized,
          msg: invalid,
        }),
      });
      return;
    }

    this.addAnother();
  }

  addAnother() {
    if (this.state.items.length && !this.state.items[this.state.items.length - 1].trim()) return;
    this.setState({
      errorMessage: null,
      items: this.state.items.concat(''),
    });
  }

  handleChangeText(text, i) {
    if (this.state.items[i] && !text) {
      this.setState({
        errorMessage: null,
      });
    }
    this.state.items[i] = text;
  }

  handleInputFocus(i) {
    this._firstFocus = false;
    this.setState({
      focusedInputIndex: i,
    });
  }

  handleInputBlur(i) {
    if (this.state.items[i].trim()) {
      if (Utils.validate[this.screenType](this.state.items[i].trim())) {
        let invalid = null;
        this.state.items.forEach((item) => {
          if (!Utils.validate[this.screenType](item.trim())) invalid = item;
        });
        if (!invalid) {
          this.setState({
            errorMessage: null,
          });
        }
      } else {
        this.setState(
          {
            errorMessage: I18n.t('invite_email_phone.validationError', {
              type: this.labelTxtCapitalized,
              msg: this.state.items[i].trim(),
            }),
          },
          () => {
            setTimeout(() => {
              this.focusInput(i);
            }, 100);
          }
        );
      }
      return;
    }

    if (this.state.items.length == 1) return;

    this.handleRemove(i);
  }

  handleRemove(i) {
    let focusOnLastItem = i !== this.state.items.length - 1;

    this.state.items.splice(i, 1);
    this.setState(
      {
        items: [].concat(this.state.items),
        focusedInputIndex: focusOnLastItem
          ? this.state.items.length - 1
          : this.state.focusedInputIndex,
      },
      () => {
        if (focusOnLastItem) {
          setTimeout(() => {
            this.focusInput(this.state.items.length - 1);
          }, 100);
        }
      }
    );
  }

  setInputRef = (i, ref) => {
    if (ref) this.inputRefs[i] = ref;
    else delete this.inputRefs[i];
  };

  focusInput(i) {
    const inputRef = this.inputRefs[i];
    if (inputRef) inputRef.focus();
  }

  handleSubmitEditing(i) {
    if (this.state.items[i].trim()) {
      if (Utils.validate[this.screenType](this.state.items[i].trim())) {
        this.addAnother();
      }
      return;
    }
  }

  handleMessageTextChange = (text) => {
    this.setState({ messageValue: text });
  };

  successMessage() {
    return this.state.errorMessage ? null : this.props.initialSuccessMessage;
  }

  /**************************************************************/

  render() {
    return (
      <Container
        scrollView={true}
        renderActivityOverlay={this.props.status === 'requesting'}
        errorMessage={this.state.errorMessage}
        successMessage={this.successMessage()}
      >
        <View style={THEME.inputsContainer}>
          <FormTextArea
            maxLength={160}
            placeholder={I18n.ac('invite_email_phone.personalMessage')}
            tipText={I18n.c1('invite_email_phone.personalMessageTip')}
            onChangeText={this.handleMessageTextChange}
          />

          {this.state.items.map((val, i) => (
            <View
              style={[
                styles.inputContainer,
                this.state.focusedInputIndex === i ? styles.inputContainerSelected : {},
              ]}
              key={`input_${i}`}
            >
              <TextInput
                style={styles.input}
                ref={(ref) => this.setInputRef(i, ref)}
                autoFocus={!this._firstFocus}
                defaultValue={val ? val : null}
                placeholder={this.labelTxtAllCaps}
                placeholderTextColor={COLOR.textLight}
                autoCorrect={false}
                autoCapitalize="none"
                keyboardType={this.isEmail ? 'email-address' : 'phone-pad'}
                returnKeyType="done"
                selectTextOnFocus={false}
                clearButtonMode="while-editing"
                onFocus={() => this.handleInputFocus(i)}
                onBlur={() => this.handleInputBlur(i)}
                onChangeText={(text) => this.handleChangeText(text, i)}
                onSubmitEditing={() => this.handleSubmitEditing(i)}
                underlineColorAndroid="transparent"
              />
              {this.state.focusedInputIndex !== i && (
                <Pressable onPress={() => this.handleRemove(i)}>
                  <Image
                    style={{ width: 18, height: 18 }}
                    source={require('../../../resources/icon-reject.png')}
                  />
                </Pressable>
              )}
            </View>
          ))}

          <AddAnotherButton onPress={this.handleAddAnotherButtonPress.bind(this)} />
        </View>
      </Container>
    );
  }
}

const styles = StyleSheet.create({
  screenPadded: {
    ...THEME.container,
    ...THEME.containerPadding,
  },
  input: THEME.input,
  errorMessage: THEME.errorMessageSmall,
  inputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  inputContainerSelected: {
    borderBottomWidth: 2,
    borderBottomColor: COLOR.textLight,
    marginBottom: 30,
  },
  removeIcon: {
    fontSize: FONT_SIZE.xlarge,
    color: COLOR.emphasis,
    marginTop: 2,
  },
});

function mapStateToProps(state, ownProps) {
  return {
    status: state.screens.invites.status,
    errorMessage: state.screens.invites.errorMessage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ sendInvitations, resetState }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InviteEmailPhone);
